import { useCurrency } from '@/lib/entities/currency';
import { SimilarObject } from '@/lib/entities/domain';

import { ITooltip } from '@/lib/shared/components/ITooltip';
import { P2, P3 } from '@/lib/shared/components/Typography';
import { ArrowIcon } from '@/lib/shared/icons';
import { staticResource } from '@/lib/shared/utils/resources';
import { toMoney } from '@/lib/shared/utils/to-money';

import { clsx } from 'clsx';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import Link from 'next/link';

import styles from './PropertyCard.module.scss';

interface IPropertyCard extends SimilarObject {
  className?: string;
}
export const PropertyCard = (props: IPropertyCard) => {
  const { t } = useTranslation('index');
  const {
    currency: { symbol: cur, value },
  } = useCurrency();
  /* todo проверить цены */
  const money = toMoney(props.price?.[value]) || 'нет цены';
  const incomeText = props.projectedIncome
    ? t('projectedIncome')
    : props.rentalPool && !props.guaranteedIncome
      ? t('rentalPool')
      : t('guaranteedIncome');
  const incomeInfo = props.projectedIncome
    ? `${props.projectedIncomePercent}% ${t('declinable.projectedPerYear')}`
    : props.rentalPool && !props.guaranteedIncome && props.rentalPoolPercent
      ? `${props.rentalPoolPercent}/${100 - props.rentalPoolPercent}%`
      : `${props.guaranteedIncomePercent} % ${t('prepositions.for')} ${props.guaranteedIncomePeriod} ${t(
          props?.guaranteedIncomePeriod && props.guaranteedIncomePeriod > 1
            ? 'declinable.years'
            : 'declinable.year'
        )}`;
  const image = staticResource(props.image) || '/images/placeholder_image.webp';

  return (
    <article className={clsx(styles.card, props.className)}>
      <Link href={'/' + props.url}>
        <div className={styles.card__top}>
          <P2>{`${props.type} | ${props.locationName}`}</P2>
        </div>
        <Image
          sizes="(max-width: 586px) 100vw, (max-width: 860px) 45vw, (max-width: 996px) 50vw, 80vw"
          className={styles.card__image}
          src={image}
          alt={props.locationName + ' card'}
          fill
        />
        {props.logoImage && (
          <Image
            sizes="(max-width: 586px) 100vw, (max-width: 860px) 45vw, (max-width: 996px) 50vw, 50vw"
            className={styles.card__logo}
            src={staticResource(props.logoImage)}
            alt={props.locationName + ' card'}
            fill
          />
        )}

        <div className={styles.card__bottom}>
          <div className={styles.card__bottomLeft}>
            <P3>
              {t('priceFrom')}{' '}
              <span suppressHydrationWarning>
                {cur}
                {money}
              </span>
            </P3>
            <div>
              <div className={styles.card__tooltipWrapper}>
                <P3>{incomeText}:</P3>
                {props.guaranteedIncome && (
                  <ITooltip
                    text={t('guaranteedTooltip')}
                    position={'top'}
                    className={styles.card__tooltipIcon}
                  />
                )}
              </div>
              <P3>{incomeInfo}</P3>
            </div>
          </div>
          <div className={styles.card__bottomRight}>
            <P2>{t('more')}</P2>
            <ArrowIcon isRight />
          </div>
        </div>
      </Link>
    </article>
  );
};
